import React, { Fragment, useEffect, useState } from 'react';

import { EnvFrame, EnvLabel } from './index.style';
import { getSiteLabel, onSiteLabel } from './siteLabel';

// Environment indicator. Renders a coloured frame (and optional label) around
// the app so the current environment is obvious at a glance - dev/uat/etc.
// Driven entirely by build-time Netlify env vars (Gatsby inlines GATSBY_*):
//   GATSBY_ENV_COLOR  a CSS colour, e.g. #16a34a. Empty/unset => no frame.
//   GATSBY_ENV_LABEL  optional text for the top tab, e.g. "DEV". Empty => no tab.
// Normal production leaves both unset and shows nothing. Once a site is chosen the tab also names it, so a
// screenshot says which customer it was taken on.
const EnvBorder: React.FC = (): React.ReactElement | null => {
  const [site, setSite] = useState(getSiteLabel());

  useEffect(() => onSiteLabel(setSite), []);

  const color = process.env.GATSBY_ENV_COLOR;

  if (!color) {
    return null;
  }

  const label = process.env.GATSBY_ENV_LABEL;

  return (
    <Fragment>
      <EnvFrame style={{ borderColor: color }} />
      {label ? <EnvLabel style={{ backgroundColor: color }}>{site ? `${label} - ${site}` : label}</EnvLabel> : null}
    </Fragment>
  );
};

export default EnvBorder;
